import React, { useState } from "react";
import Select from "react-select";
import { AlertTriangle } from "lucide-react";

// 🔵 Mock guest data for dropdown
const mockGuests = [
  { id: 1, name: "Chinedu Okafor", img: require("../assets/user1.png") },
  { id: 2, name: "Ngozi Adeyemi", img: require("../assets/user2.png") },
  { id: 3, name: "Tunde Balogun", img: require("../assets/user3.png") },
  { id: 4, name: "Tunde Balogun", img: require("../assets/user3.png") },
  { id: 5, name: "Tunde Balogun", img: require("../assets/user3.png") },
  { id: 6, name: "Tunde Balogun", img: require("../assets/user3.png") },
  { id: 7, name: "Tunde Balogun", img: require("../assets/user3.png") },
  { id: 8, name: "Tunde Balogun", img: require("../assets/user3.png") },
  { id: 9, name: "Tunde Balogun", img: require("../assets/user3.png") },
  { id: 10, name: "Tunde Balogun", img: require("../assets/user3.png") },
];

// ✅ Transform for react-select
const guestOptions = mockGuests.map((guest) => ({
  value: guest.id,
  label: guest.name,
  img: guest.img,
}));

// ✅ Custom option with image
const CustomOption = (props) => {
  const { innerProps, data } = props;
  return (
    <div
      {...innerProps}
      className="d-flex align-items-center p-2"
      style={{ cursor: "pointer" }}
    >
      <img
        src={data.img}
        alt={data.label}
        style={{
          width: "30px",
          height: "30px",
          borderRadius: "50%",
          marginRight: "10px",
        }}
      />
      <span>{data.label}</span>
    </div>
  );
};

export default function CheckOutModal({ show, onClose }) {
  const [selectedGuest, setSelectedGuest] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleCheckOut = () => {
    if (!selectedGuest) return;

    setLoading(true);

    setTimeout(() => {
      setLoading(false);
      alert(`${selectedGuest.label} has been checked out successfully!`);
      setSelectedGuest(null);
      onClose();
    }, 2000); // simulate API call
  };

  return (
    <div
      className={`modal fade ${show ? "show d-block" : ""}`}
      tabIndex="-1"
      style={{ background: show ? "rgba(0,0,0,0.5)" : "transparent" }}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          {/* 🔵 Modal Header */}
          <div className="modal-header">
            <h5 className="modal-title fw-bold">Guest Check-Out</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>

          {/* 🔵 Modal Body */}
          <div className="modal-body">
            {/* ⚠️ Warning Banner */}
            <div className="alert alert-warning d-flex align-items-center gap-2">
              
              <div>
                <strong className="method-name">Important:</strong> Once this guest is checked out, they
                must go through verification again to be checked back in.
              </div>
            </div>

            {/* ✅ Dropdown */}
            <div className="mb-4">
              <label className="form-label fw-bold">Select Guest to Check-Out</label>
              <Select
                options={guestOptions}
                placeholder="Search guest..."
                components={{ Option: CustomOption }}
                onChange={setSelectedGuest}
                value={selectedGuest}
                isClearable
              />
            </div>
          </div>

          {/* 🔵 Modal Footer */}
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button
              className="btn btn-danger"
              onClick={handleCheckOut}
              disabled={!selectedGuest || loading}
            >
              {loading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                  ></span>
                  Checking Out...
                </>
              ) : (
                `Check Out`
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
